import React from "react";
import { Control, Controller, UseFormSetValue } from "react-hook-form";
import InputBox from "./InputBox";
import './InputBox.scss';
import { useController } from "react-hook-form";

type ControlInputBoxType = {
  required?: boolean;
  isTextArea?: boolean;
  control: Control<any>;
  name: string;
  showLabel: boolean;
  label: string;
  readonly?: boolean;
  defaultValue?: string;
  setValue?: UseFormSetValue<any>;
  maxLength?: string;
  onChange?: (e: any) => void;
  placeholder?: string;
  disabled?: boolean;
};

export default function ControlInputBox({
  name,
  control,
  required = false,
  isTextArea = false,
  showLabel,
  label,
  readonly = false,
  defaultValue,
  setValue,
  maxLength,
  onChange,
  ...inputArgs
}: ControlInputBoxType) {
  const { field } = useController({
    name,
    control,
    rules: { required: required },
  });

  return (
    <>
      {showLabel && (
        <div className="formFieldLabel">
          <label htmlFor="input" aria-label={label}>
            {label}
            {required ? <span className="requiredSymbol">*</span> : ""}
          </label>
        </div>
      )}
      <Controller
        name={field.name}
        control={control}
        rules={{ required }}
        render={({ field: { onChange: onFieldChange, value, ...args } }) => {
          return (
            <>
              <InputBox
                id={field.name}
                required={true}
                value={value || ""}
                onChange={(e) => {
                  onFieldChange(e);
                  if (onChange) {
                    onChange(e);
                  }
                }}
                isTextArea={isTextArea}
                readonly={readonly}
                maxLength={maxLength}
                {...args}
                {...inputArgs}
              />
            </>
          );
        }}
      />
    </>
  );
}
